<template>
  <button :outline="outline" :size="size" :style="getStyling" :disabled="disabled" @click="clicked" class="framework-button">
    <slot name="button-content"></slot>
  </button>
</template>

<script>
import colors from '@/assets/scss/MotivateColors.scss';


export default {
  name: "Button",
  props: ['color', 'disabled', 'backgroundColor', 'size', 'outline'],
  computed: {
    getStyling() {
      let css = {};
      css['color'] = this.outline ? (this.color ? this.color : colors.ceruleanBlue) : (this.color ? this.color : colors.walterWhite);
      css['background-color'] = this.outline ? (this.backgroundColor ? this.backgroundColor : colors.walterWhite) : (this.backgroundColor ? this.backgroundColor : colors.ceruleanBlue);
      if (this.outline) {
        css['border'] = `1px solid ${(this.color ? this.color : colors.ceruleanBlue) }`
      }
      css['cursor'] = 'pointer'
      return css  ;
    }
  },
  methods: {
    clicked($event) {
      this.$emit('frameworkButtonClicked', $event);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/frameWorkButton.scss";

</style>
